import { render, staticRenderFns } from "./Care.vue?vue&type=template&id=6e2fe9fa&"
import script from "./Care.vue?vue&type=script&lang=js&"
export * from "./Care.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports